import React from "react";
import { Link } from "react-router-dom";
import {
  Users,
  Briefcase,
  MessagesSquare,
  ClipboardCheck,
  Layers,
  UserCheck,
  UserPlus,
  UserMinus,
} from "lucide-react";

import { useGetPlatformKpiQuery } from "../reactWrapper/Redux/apiSlice";
import PageIntro from "../components/PageIntro/PageIntro";
import LoadingSpinner from "../components/Loader/LoadingSpinner";
import { StatTile } from "../components/ui-x";

/* The old tiles carried an assortment of orange-200 / orange-600 / orange-700 /
   red-200 / red-400 icon chips that encoded nothing. StatTile's neutral
   navy-100 chip is the reference's single icon-chip treatment. */
const KPIS = [
  { key: "allUser", label: "Users", icon: Users },
  { key: "allTalent", label: "Talents", icon: Briefcase },
  { key: "allInterviewed", label: "Interviewed", icon: MessagesSquare },
  { key: "allPassed", label: "Passed", icon: ClipboardCheck },
  { key: "allGigMatchRequest", label: "Accepted Offer", icon: Layers },
  { key: "allHardSkillTested", label: "CBT Tested", icon: ClipboardCheck },
  { key: "allUsersWithUpdatedProfile", label: "Updated profiles", icon: UserCheck },
  { key: "allUsersWithCompletedProfile", label: "Completed profiles", icon: UserPlus },
];

const LEVELS = [
  { key: "allJuniorLevelTalents", label: "Junior Level" },
  { key: "allMidLevelTalents", label: "Intermediate Level" },
  { key: "allSeniorLevelTalents", label: "Senior Level" },
];

const HomeAdminDashboard = () => {
  const { data: platformKpi, isLoading: isPlatformKpiLoading } =
    useGetPlatformKpiQuery();

  if (isPlatformKpiLoading) return <LoadingSpinner />;

  return (
    <div className="mx-auto max-w-7xl space-y-8">
      <PageIntro
        title="Dashboard"
        description="Platform activity at a glance."
      />

      {/* Rule 8: KPI rows are a grid of StatTile */}
      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {KPIS.map(({ key, label, icon: Icon }) => (
          <StatTile
            key={key}
            label={label}
            value={platformKpi?.[key] ?? "—"}
            icon={<Icon className="h-4 w-4" />}
          />
        ))}

        {/* The only tile that navigates, so it is the only one that hovers. */}
        <Link to="/talent-incomplete-profile" className="block">
          <StatTile
            label="Incompleted profiles"
            value={platformKpi?.allUserwithInCompletedProfile ?? "—"}
            icon={<UserMinus className="h-4 w-4" />}
            sub="View all"
            className="h-full transition-colors hover:border-brand-orange"
          />
        </Link>
      </div>

      <section className="rounded-2xl border bg-card p-5 shadow-ui-sm">
        <div className="text-[11px] font-semibold uppercase tracking-wider text-brand-orange">
          Breakdown
        </div>
        <h2 className="font-display text-lg font-semibold text-brand-navy">Talents Level</h2>

        <ul className="mt-4 divide-y">
          {LEVELS.map(({ key, label }) => (
            <li
              key={key}
              className="flex items-center justify-between py-3 text-sm"
            >
              <span className="text-muted-foreground">{label}</span>
              <span className="font-semibold tabular-nums text-brand-navy">
                {platformKpi?.[key] ?? "—"}
              </span>
            </li>
          ))}
        </ul>
      </section>
    </div>
  );
};

export default HomeAdminDashboard;
